import { render, staticRenderFns } from "./create-outline.vue?vue&type=template&id=72dd5c50&scoped=true&"
import script from "./create-outline.vue?vue&type=script&lang=js&"
export * from "./create-outline.vue?vue&type=script&lang=js&"
import style0 from "./create-outline.vue?vue&type=style&index=0&id=72dd5c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd5c50",
  null
  
)

export default component.exports